module.exports = __webpack_public_path__ + "img/cuciPoint.2500b880.png";